export enum WorkflowStatus{
    AWAITING_VALIDATION='AWAITING_VALIDATION',
    REJECTED="REJECTED"
}
